module.exports = "/assets/data/6a400456fd4bf027166204c993fa6b0c-CF3.data.json";